import queryString from "query-string";
import { useEffect, useState } from "react";

import { Loader } from "../../components";
import { useAxios, useComponent } from "../../hooks";
import {
  companyObject,
  objectFromResponseData,
} from "../company components/company details components/companyDetailsObject";
import FormDisplay from "./unverified company details/FormDisplay";

export default function UnverifiedCompanyAgencyDetails() {
  const axios = useAxios();
  const { loader } = useComponent();

  const [editState, setEditState] = useState(true);
  const [noDetails, setNoDetails] = useState(false);
  const [formData, setFormData] = useState(companyObject);
  const platformID = queryString.parse(window.location.search).platformID;
  const agencyID = queryString.parse(window.location.search).agencyID;

  useEffect(() => {
    loader.start(1);

    if (formData.ID) {
      setEditState(false);
    }
    if (!!agencyID) {
      axios({
        url: "/getCompany/" + agencyID + "?type=AGENCY",
      }).then((response) => {
        if (response.status) {
          if (Object.keys(response.data).length > 0) {
            if (response.data.is_agency_verified === 0) {
              setEditState(false);
            }
            setFormData(objectFromResponseData(response.data));
          }
          loader.stop();
        } else {
          setNoDetails(true);
          setFormData(companyObject);
          loader.stop();
        }
      });
    } else {
      loader.stop();
    }
  }, [axios, agencyID, loader, formData.ID]);

  return (
    <Loader>
      <FormDisplay
        agencyID={agencyID}
        platformID={platformID}
        setEditState={setEditState}
        editState={editState}
        noDetails={noDetails}
        formData={formData}
        setFormData={setFormData}
      />
    </Loader>
  );
}
